import { render, staticRenderFns } from "./KeyFeatures.vue?vue&type=template&id=00e5ec80&"
import script from "./KeyFeatures.vue?vue&type=script&lang=js&"
export * from "./KeyFeatures.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/azureagent/_work/5/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00e5ec80')) {
      api.createRecord('00e5ec80', component.options)
    } else {
      api.reload('00e5ec80', component.options)
    }
    module.hot.accept("./KeyFeatures.vue?vue&type=template&id=00e5ec80&", function () {
      api.rerender('00e5ec80', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Company/KeyFeatures.vue"
export default component.exports